import * as React from 'react';
import { SelectDropdown } from '../../../../internal/components/SelectDropdown';
import { ensureChildrenVisibility, SELECT_ALL_INDEX } from '../../../internal';
import { MultiSelectDesktopDropdownItem } from '../MultiSelectDesktopDropdownItem';
import styles from './styles.module.css';
import { generateDataTestId } from '../../../../internal/utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectDesktopDropdown(props) {
  const {
    open,
    value,
    options,
    name,
    focusedIndex,
    actions,
    onKeyDown,
    allOptionLabel,
    insideRefs,
    dataTestId
  } = props;
  const optionsContainerRef = React.useRef(null);
  const focusedOptionRef = React.useRef(null);
  React.useEffect(() => {
    const optionsContainer = optionsContainerRef.current;
    const focusedOption = focusedOptionRef.current;
    if (open && optionsContainer && focusedOption) {
      ensureChildrenVisibility(optionsContainer, focusedOption);
      focusedOption.focus();
    }
  }, [open, focusedIndex]);
  const bindHandleOptionClickIndex = index => () => {
    actions.toggleOptionState(index);
  };
  const bindHandleOptionMouseMoveIndex = index => () => {
    if (focusedIndex !== index) {
      actions.setFocusedIndex(index);
    }
  };
  const allOptionFocused = focusedIndex === SELECT_ALL_INDEX;
  return /*#__PURE__*/_jsx(SelectDropdown, {
    onClose: actions.closeDropdown,
    insideRefs: insideRefs,
    children: /*#__PURE__*/_jsxs("div", {
      ref: optionsContainerRef,
      className: styles['checkbox-group'],
      role: "listbox",
      "data-testid": generateDataTestId(dataTestId, ['dropdown']),
      onKeyDown: onKeyDown,
      children: [allOptionLabel && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MultiSelectDesktopDropdownItem, {
          ref: allOptionFocused ? focusedOptionRef : undefined,
          value: "allOption",
          label: allOptionLabel,
          name: name,
          focused: allOptionFocused,
          selected: (value === null || value === void 0 ? void 0 : value.length) === options.length,
          dataTestId: generateDataTestId(dataTestId, ['allOption']),
          onClick: actions.toggleAllOptionState,
          onMouseMove: bindHandleOptionMouseMoveIndex(SELECT_ALL_INDEX)
        }), /*#__PURE__*/_jsx("span", {
          className: styles['divider']
        })]
      }), options.map((option, index) => {
        const optionValue = option.value;
        const key = String(optionValue);
        const focused = index === focusedIndex;
        const selected = (value || []).includes(optionValue);
        return /*#__PURE__*/_jsx(MultiSelectDesktopDropdownItem, {
          ref: focused ? focusedOptionRef : undefined,
          value: key,
          label: option.label,
          description: option.description,
          name: name,
          focused: focused,
          selected: selected,
          dataTestId: generateDataTestId(dataTestId, [key]),
          onClick: bindHandleOptionClickIndex(index),
          onMouseMove: bindHandleOptionMouseMoveIndex(index)
        }, key);
      })]
    })
  });
}